<nav vid="7">
    <div class="container nav-inner" vid="8">
        <div class="logo" vid="9">
            <img class="logo-mark" vid="10" src="https://shared.avs-api.com/icons/avs/apps/delivery-ops/logo.png">
            Delivery Ops
        </div>
        <div class="nav-links" vid="11" *ngIf="isLoggedIn()">
            <a [routerLink]="['/']" vid="12">Home</a>
            <a [routerLink]="['/routes-view']" vid="13">Routes</a>
            <a [routerLink]="['/create-route']" vid="14">Create Routes</a>
        </div>
          <div class="nav-links" vid="11" *ngIf="!isLoggedIn()">
            <a [routerLink]="['/']" vid="12">Home</a>
            <a [routerLink]="['/sub-pricing']" vid="13">Pricing</a>
        </div>
        <button class="btn-primary" vid="15" (click)="login()" *ngIf="!isLoggedIn()">Login</button>
        <button class="btn-primary" vid="15" (click)="logout()" *ngIf="isLoggedIn()">Logout</button>

    </div>
</nav>
<router-outlet></router-outlet>